import React, { type ChangeEvent, forwardRef, useCallback } from 'react';

import { Input } from 'antd';
import type { InputRef } from 'antd';

import useMask, { type BuiltInMasks } from './masks';

type MaskedInputProps = {
  id: string;
  name?: string;
  mask: BuiltInMasks;
  value?: string;
  message: '' | 'error';
  type?: 'string' | 'number';
  onChange?: (value: number | string) => void;
  disabled?: boolean;
  maxLength?: number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  placeholder?: string;
};

const MaskedInput = forwardRef<InputRef, MaskedInputProps>(
  ({ id, name, mask, value, onChange, type, disabled, maxLength, prefix, suffix, placeholder, message }, ref) => {
    const { maskClean, maskedValue } = useMask(mask, value);

    const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        const cleanValue = maskClean(e.currentTarget.value);

        if (onChange) {
          onChange(type === 'number' ? Number(cleanValue || 0) : cleanValue);
        }
      },
      [maskClean, onChange, type]
    );

    return (
      <Input
        name={name}
        value={maskedValue}
        ref={ref}
        status={message}
        onChange={handleChange}
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        prefix={prefix}
        suffix={suffix}
        placeholder={placeholder}
      />
    );
  }
);

export default MaskedInput;
